import { render, staticRenderFns } from "./MunicipalitiesSettings.vue?vue&type=template&id=26caf0e1&"
import script from "./MunicipalitiesSettings.vue?vue&type=script&lang=js&"
export * from "./MunicipalitiesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports